import { useAuth } from "@client/hooks";
import { LoginPage } from "./LoginPage";

interface AuthWrapperProps {
	children: React.ReactNode;
}

export function AuthWrapper({ children }: AuthWrapperProps) {
	const { isAuthenticated, user, isLoading } = useAuth();

	// Show loading state while checking authentication
	if (isLoading) {
		console.log("🔍 AuthWrapper: Showing loading state");
		return (
			<div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gray-50 dark:bg-gray-900">
				<div className="text-center">
					<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
					<p className="text-gray-600 dark:text-gray-400">Loading...</p>
				</div>
			</div>
		);
	}

	// Show login page if not authenticated
	if (!isAuthenticated || !user) {
		console.log("🔍 AuthWrapper: No authenticated user, showing login page");
		return <LoginPage />;
	}

	// Show main app if authenticated
	return <>{children}</>;
}
